var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quick-card',{attrs:{"title":"General Class Settings"},scopedSlots:_vm._u([{key:"card-content",fn:function(){return [_vm._v("hello")]},proxy:true}])})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e12587c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/settings/classGen.vue
// module id = s9pU
// module chunks = 0